import moment from 'moment';

export const URL_DATE_FORMAT = 'YYYY-MM-DD';
export const MES_FORMAT = 'YYYY-MM';

export const ESTADO_VIOLACAO = 'VIOLACAO';
export const ESTADO_EXTRA_100 = 'EXTRA_100';
export const ESTADO_AUSENCIA = 'AUSENCIA';

export const REGRAS = [
  {
    id: 'EXTRA_DIARIA',
    label: '>2h extra/dia',
    short: 'R1',
    statColor: 'error',
    kpiKey: 'extraDiaria',
  },
  {
    id: 'ALMOCO',
    label: 'Almoço <1h',
    short: 'R2',
    statColor: 'warning',
    kpiKey: 'almoco',
  },
  {
    id: 'DIAS_CONSECUTIVOS',
    label: '7+ dias seguidos',
    short: 'R3',
    statColor: 'primary',
    kpiKey: 'diasConsecutivos',
  },
  {
    id: 'EXTRA_CICLO',
    label: '>52h no ciclo',
    short: 'R4',
    statColor: 'error',
    kpiKey: 'extraCiclo',
  },
  {
    id: 'SEM_JORNADA',
    label: 'Sem jornada',
    short: 'R5',
    statColor: 'default',
    kpiKey: 'semJornada',
    hint: 'Dia em que a jornada era esperada e não foi registrada. Pode incluir férias, atestado ou afastamento.',
  },
];

const REGRA_BY_ID = REGRAS.reduce((acc, regra) => {
  acc[regra.id] = regra;
  return acc;
}, {});

const REGRA_ALIASES = {
  EXTRA_DIARIA: 'EXTRA_DIARIA',
  R1: 'EXTRA_DIARIA',
  TETO_DIARIO: 'EXTRA_DIARIA',
  ALMOCO: 'ALMOCO',
  R2: 'ALMOCO',
  INTERVALO: 'ALMOCO',
  DIAS_CONSECUTIVOS: 'DIAS_CONSECUTIVOS',
  R3: 'DIAS_CONSECUTIVOS',
  SEQUENCIA: 'DIAS_CONSECUTIVOS',
  EXTRA_CICLO: 'EXTRA_CICLO',
  R4: 'EXTRA_CICLO',
  TETO_CICLO: 'EXTRA_CICLO',
  SEM_JORNADA: 'SEM_JORNADA',
  R5: 'SEM_JORNADA',
  INDETERMINADO_SEM_JORNADA: 'SEM_JORNADA',
  INTERMITENTE_SEM_PONTO: 'SEM_JORNADA',
  INTERMITENTE_SEM_CONVOCACAO: 'SEM_JORNADA',
  JORNADA_FORA_DA_REGUA: 'SEM_JORNADA',
  EXTRA_100: 'EXTRA_100',
  DOMINGO_FERIADO: 'EXTRA_100',
  FERIADO: 'EXTRA_100',
};

export const REGIMES = [
  { id: 'INDETERMINADO', nome: 'Indeterminado' },
  { id: 'INTERMITENTE', nome: 'Intermitente' },
];

export const REGIME_TABS = [
  { id: 'GERAL', label: 'Geral' },
  { id: 'INTERMITENTE', label: 'Intermitente' },
  { id: 'INDETERMINADO', label: 'Indeterminado' },
];

export const CICLO_ATUAL = 'ATUAL';
export const CICLO_PASSADO = 'PASSADO';
export const CICLO_CUSTOM = 'CUSTOM';

export const CICLOS = [
  { id: CICLO_ATUAL, nome: 'Atual' },
  { id: CICLO_PASSADO, nome: 'Passado' },
  { id: CICLO_CUSTOM, nome: 'Custom' },
];

export const SECOES = ['KPIS', 'RANKING', 'DETALHADO'];

export const formatInspetorDias = (inspetores, dias, horas) => {
  const pessoas = Number(inspetores) === 1 ? 'inspetor' : 'inspetores';
  let text = pessoas;
  if (dias != null && dias !== '') {
    text = `${pessoas} em ${dias} ${Number(dias) === 1 ? 'dia' : 'dias'}`;
  }
  if (horas) text = `${text} · ${horas}`;
  return text;
};

export const EMPTY_KPIS = REGRAS.reduce((acc, regra) => {
  acc[regra.id] = { inspetores: 0, dias: null, horas: null };
  return acc;
}, {});

export const EMPTY_REPORT = {
  kpis: EMPTY_KPIS,
  ranking: [],
  dias: [],
};

/** Ciclo 26→25. Cópia local — não importar de RelatorioDigitacao. */
export const getMedicaoPeriod = (ref = moment()) => {
  const m = moment(ref);
  const day = m.date();
  let inicio;
  let fim;
  if (day >= 26) {
    inicio = m.clone().date(26).startOf('day');
    fim = m.clone().add(1, 'month').date(25).endOf('day');
  } else {
    inicio = m.clone().subtract(1, 'month').date(26).startOf('day');
    fim = m.clone().date(25).endOf('day');
  }
  return { inicio: inicio.valueOf(), fim: fim.valueOf() };
};

export const getPreviousMedicaoPeriod = (ref = moment()) => {
  const current = getMedicaoPeriod(ref);
  return getMedicaoPeriod(moment(current.inicio).subtract(1, 'day'));
};

const sameCalendarDay = (a, b) => moment(a).format(URL_DATE_FORMAT) === moment(b).format(URL_DATE_FORMAT);

export const inferCiclo = (inicio, fim) => {
  const atual = getMedicaoPeriod();
  const passado = getPreviousMedicaoPeriod();
  if (sameCalendarDay(inicio, atual.inicio) && sameCalendarDay(fim, atual.fim)) return CICLO_ATUAL;
  if (sameCalendarDay(inicio, passado.inicio) && sameCalendarDay(fim, passado.fim)) return CICLO_PASSADO;
  return CICLO_CUSTOM;
};

export const periodForCiclo = (ciclo, ref = moment()) => (
  ciclo === CICLO_PASSADO ? getPreviousMedicaoPeriod(ref) : getMedicaoPeriod(ref)
);

/** Atual e Passado travam início/fim. Custom mantém as datas já escolhidas. */
export const applyCicloToFilter = (filter) => {
  const ciclo = filter?.ciclo || CICLO_ATUAL;
  if (ciclo === CICLO_CUSTOM) return { ...filter, ciclo };
  const period = periodForCiclo(ciclo);
  return { ...filter, ciclo, inicio: period.inicio, fim: period.fim };
};

export const getDefaultView = () => {
  const period = getMedicaoPeriod();
  return {
    ciclo: CICLO_ATUAL,
    inicio: period.inicio,
    fim: period.fim,
    regime: null,
    regra: null,
    inspetorId: null,
    visao: null,
    mes: moment(period.fim).format(MES_FORMAT),
  };
};

export const formatPeriodLabel = (inicio, fim) => {
  if (inicio == null || fim == null) return '';
  return `${moment(inicio).format('DD/MM/YYYY')} – ${moment(fim).format('DD/MM/YYYY')}`;
};

export const isPeriodInvalid = (inicio, fim) => {
  if (inicio == null || fim == null) return true;
  return moment(inicio).startOf('day').isAfter(moment(fim).endOf('day'));
};

export const getRegra = (id) => REGRA_BY_ID[id] || null;

export const chipColor = (regraId) => {
  const regra = getRegra(regraId);
  if (!regra || regra.statColor === 'default') return 'default';
  if (regra.statColor === 'primary') return 'primary';
  if (regra.statColor === 'warning') return 'warning';
  return 'error';
};

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const canonicalRegra = (value) => {
  if (value == null) return null;
  const key = String(value).trim().toUpperCase().replace(/\s+/g, '_');
  return REGRA_ALIASES[key] || (REGRA_BY_ID[key] ? key : null);
};

const asList = (value) => {
  if (value == null) return [];
  if (Array.isArray(value)) return value;
  return [value];
};

const readRegras = (node) => {
  const raw = node?.regras || node?.tiposViolacao || node?.tipos || node?.regra || [];
  const ids = [];
  asList(raw).forEach((item) => {
    const id = canonicalRegra(typeof item === 'object' ? item?.tipo || item?.id || item?.codigo : item);
    if (id && id !== 'EXTRA_100' && !ids.includes(id)) ids.push(id);
  });
  return ids;
};

const readEstados = (node, regras) => {
  const raw = node?.estados || node?.estado || node?.tipoVisual || [];
  const estados = [];
  asList(raw).forEach((item) => {
    const key = String(item || '').trim().toUpperCase();
    if (key === 'VIOLACAO' || key === ESTADO_VIOLACAO) estados.push(ESTADO_VIOLACAO);
    if (key === 'AUSENCIA' || key === ESTADO_AUSENCIA || key === 'SEM_JORNADA') estados.push(ESTADO_AUSENCIA);
    if (key === 'EXTRA_100' || key === 'EXTRA100' || key === 'DOMINGO_FERIADO') estados.push(ESTADO_EXTRA_100);
  });
  if (canonicalRegra(node?.tipo) === 'EXTRA_100' || node?.extra100 === true || node?.domingoFeriado === true) {
    estados.push(ESTADO_EXTRA_100);
  }
  if (regras.includes('SEM_JORNADA')) estados.push(ESTADO_AUSENCIA);
  if (regras.some((id) => id !== 'SEM_JORNADA')) estados.push(ESTADO_VIOLACAO);
  return [...new Set(estados)];
};

const readDetalhes = (node) => {
  const raw = node?.detalhes || node?.descricoes || node?.descricao || [];
  return asList(raw)
    .map((item) => {
      if (typeof item === 'string') return item;
      return item?.texto || item?.descricao || item?.label || '';
    })
    .filter(Boolean);
};

export const parseDia = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'number') {
    const m = moment(value);
    return m.isValid() ? m : null;
  }
  if (typeof value === 'string' && /^\d{12,}$/.test(value)) {
    const m = moment(Number(value));
    return m.isValid() ? m : null;
  }
  const parsed = moment(value, [URL_DATE_FORMAT, 'DD/MM/YYYY', moment.ISO_8601], true);
  if (parsed.isValid()) return parsed;
  const loose = moment(value);
  return loose.isValid() ? loose : null;
};

const readKpiNode = (node) => {
  if (typeof node === 'number') return { inspetores: node, dias: null, horas: null };
  const diasRaw = node?.dias ?? node?.diasTotal ?? node?.ocorrencias;
  const horas = node?.horas ?? node?.horasForaTeto ?? node?.horaExtraForaTeto;
  return {
    inspetores: toNumber(node?.inspetores ?? node?.quantidadeInspetores ?? node?.total ?? 0),
    dias: diasRaw == null || diasRaw === '' ? null : toNumber(diasRaw),
    horas: horas ? String(horas) : null,
  };
};

const unwrap = (data) => {
  if (data?.kpis || data?.KPIS || data?.ranking || data?.RANKING || data?.detalhado || data?.DETALHADO) {
    return data;
  }
  if (data?.data && typeof data.data === 'object') return data.data;
  return data || {};
};

const readKpis = (root) => {
  const raw = root.kpis || root.KPIS || root.kpi || {};
  const kpis = { ...EMPTY_KPIS };
  if (Array.isArray(raw)) {
    raw.forEach((item) => {
      const id = canonicalRegra(item?.tipo || item?.regra || item?.id);
      if (id && id !== 'EXTRA_100' && kpis[id]) kpis[id] = readKpiNode(item);
    });
    return kpis;
  }
  REGRAS.forEach((regra) => {
    const node = raw[regra.kpiKey] || raw[regra.id] || raw[regra.short] || raw[regra.short.toLowerCase()];
    if (node != null) kpis[regra.id] = readKpiNode(node);
  });
  return kpis;
};

const readDuracao = (row, keys) => {
  const sources = [row, row?.resumo, row?.RESUMO];
  for (let i = 0; i < sources.length; i += 1) {
    const source = sources[i];
    if (!source || typeof source !== 'object') continue;
    for (let j = 0; j < keys.length; j += 1) {
      const value = source[keys[j]];
      if (value != null && String(value).trim() !== '') return String(value).trim();
    }
  }
  return null;
};

export const parseDuracaoMinutos = (value) => {
  if (value == null || value === '') return null;
  const match = String(value).trim().match(/^(\d+):(\d{2})$/);
  if (!match) return null;
  return (Number(match[1]) * 60) + Number(match[2]);
};

export const formatDuracao = (minutes) => {
  if (minutes == null || !Number.isFinite(minutes)) return null;
  const sign = minutes < 0 ? '−' : minutes > 0 ? '+' : '';
  const abs = Math.abs(Math.round(minutes));
  const horas = Math.floor(abs / 60);
  const mins = abs % 60;
  return `${sign}${horas}:${String(mins).padStart(2, '0')}`;
};

const readCount = (row, key) => {
  const value = row?.[key];
  if (value == null || value === '') return null;
  return toNumber(value);
};

export const resumoHoras = (row) => {
  const esperado = row?.horasEsperadas || null;
  const registrado = row?.horasRegistradas || row?.horasTrabalhadas || null;
  const esperadoMin = parseDuracaoMinutos(esperado);
  const registradoMin = parseDuracaoMinutos(registrado);
  const diferenca = esperadoMin != null && registradoMin != null
    ? formatDuracao(registradoMin - esperadoMin)
    : null;
  const diasUteis = row?.diasUteisEsperados ?? null;
  const sabados = row?.sabadosEsperados ?? null;
  return { esperado, registrado, diferenca, diasUteis, sabados };
};

export const buildJornadaListUrl = ({ inicio, fim, inspetorId, jornadaId, listagem = false }) => {
  const q = new URLSearchParams();
  if (listagem) {
    q.set('p', '0');
    q.set('s', '10');
  }
  if (inicio != null) q.set('inicio', moment(inicio).format(URL_DATE_FORMAT));
  if (fim != null) q.set('fim', moment(fim).format(URL_DATE_FORMAT));
  if (inspetorId) q.set('usuarioId', String(inspetorId));
  if (jornadaId) q.set('id', String(jornadaId));
  const qs = q.toString();
  return qs ? `/v2/jornada?${qs}` : '/v2/jornada';
};

export const monthsInPeriod = (inicio, fim) => {
  if (inicio == null || fim == null) return [];
  const cursor = moment(inicio).startOf('month');
  const end = moment(fim).startOf('month');
  const months = [];
  while (cursor.isSameOrBefore(end, 'month')) {
    months.push(cursor.format(MES_FORMAT));
    cursor.add(1, 'month');
  }
  return months;
};

export const sortRanking = (rows, field, direction) => {
  const dir = direction === 'desc' ? -1 : 1;
  return [...(rows || [])].sort((a, b) => {
    if (field === 'diasViolacao') return dir * (a.diasViolacao - b.diasViolacao);
    if (field === 'regras') {
      const byCount = a.regras.length - b.regras.length;
      if (byCount !== 0) return dir * byCount;
      return dir * a.regras.join(',').localeCompare(b.regras.join(','), 'pt-BR');
    }
    return dir * String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR', { sensitivity: 'base' });
  });
};

const readRanking = (root) => {
  const list = root.ranking || root.RANKING || root.rankingInspetores || [];
  if (!Array.isArray(list)) return [];
  return list.map((row, index) => {
    const inspetorId = row?.inspetorId || row?.usuarioId || row?.id || `row-${index}`;
    return {
      id: String(inspetorId),
      inspetorId: String(inspetorId),
      nome: row?.nome || row?.inspetorNome || row?.nomeInspetor || '—',
      regime: labelRegime(row?.regime || row?.regimeNome || row?.regimeTrabalho),
      diasViolacao: toNumber(row?.diasViolacao ?? row?.diasComViolacao ?? row?.dias ?? 0),
      horaExtraForaTeto: row?.horaExtraForaTeto || row?.horasForaTeto || row?.horaExtra || '—',
      horasEsperadas: readDuracao(row, ['horasEsperadas', 'jornadaEsperada', 'esperado']),
      horasRegistradas: readDuracao(row, ['horasRegistradas', 'horasTrabalhadas', 'jornadaTrabalhada', 'realizado', 'feito']),
      diasUteisEsperados: readCount(row, 'diasUteisEsperados'),
      sabadosEsperados: readCount(row, 'sabadosEsperados'),
      regras: readRegras(row),
    };
  });
};

const FERIADO_TIPO_LABEL = {
  NACIONAL: 'Nacional',
  ESTADUAL: 'Estadual',
  MUNICIPAL: 'Municipal',
  FACULTATIVO: 'Facultativo',
  DAY_OFF_ANIVERSARIO: 'Day off aniversário',
};

export const labelFeriadoTipo = (tipo) => FERIADO_TIPO_LABEL[tipo] || '';

const readFeriado = (row) => {
  const raw = row?.feriado;
  if (!raw || typeof raw !== 'object') return null;
  const nome = String(raw.nome || '').trim();
  const tipo = String(raw.tipo || '').trim().toUpperCase();
  if (!nome && !tipo) return null;
  return { nome, tipo: tipo || null };
};

const PONTO_ORDEM = ['INICIO_JORNADA', 'INICIO_INTERVALO', 'FIM_INTERVALO', 'FIM_JORNADA'];

const readHorario = (value) => {
  if (value == null || value === '') return null;
  const text = String(value).trim();
  const clock = text.match(/^(\d{1,2}):(\d{2})/);
  if (clock) return `${clock[1].padStart(2, '0')}:${clock[2]}`;
  const parsed = moment(text, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss'], true);
  if (parsed.isValid()) return parsed.format('HH:mm');
  return null;
};

const readPontos = (row) => {
  const byTipo = {};
  asList(row?.pontos || row?.itens).forEach((item) => {
    if (!item || typeof item !== 'object') return;
    const tipo = String(item.tipo || '').trim().toUpperCase();
    const horario = readHorario(item.horario || item.hora);
    if (!tipo || !horario) return;
    byTipo[tipo] = horario;
  });
  return PONTO_ORDEM.map((tipo) => ({ tipo, horario: byTipo[tipo] || null }));
};

const mapDia = (row, index, fallbackInspetorId) => {
  const dia = parseDia(row?.data || row?.dia);
  const regras = readRegras(row);
  const inspetorId = String(row?.inspetorId || row?.usuarioId || fallbackInspetorId || '');
  return {
    id: `${inspetorId || 'x'}-${dia ? dia.format(URL_DATE_FORMAT) : index}-${index}`,
    inspetorId,
    nome: row?.nome || row?.inspetorNome || row?.nomeInspetor || '',
    data: dia,
    dataKey: dia ? dia.format(URL_DATE_FORMAT) : '',
    regras,
    estados: readEstados(row, regras),
    detalhes: readDetalhes(row),
    jornadaId: row?.jornadaId || row?.jornada?.id || null,
    horasEsperadas: readDuracao(row, ['horasEsperadas']),
    horasRegistradas: readDuracao(row, ['horasRegistradas', 'horasTrabalhadas']),
    pontos: readPontos(row),
    feriado: readFeriado(row),
  };
};

const readDias = (root) => {
  const list = root.dias || root.detalhado || root.DETALHADO || root.violacoes || [];
  if (!Array.isArray(list)) return [];
  return list.map((row, index) => mapDia(row, index)).filter((row) => row.data);
};

export const normalizeCalendarioDias = (data, inspetorId) => {
  const list = Array.isArray(data)
    ? data
    : (data?.dias || data?.data || data?.detalhado || []);
  if (!Array.isArray(list)) return [];
  return list.map((row, index) => mapDia(row, index, inspetorId)).filter((row) => row.data);
};

export const normalizeBiResponse = (data) => {
  const root = unwrap(data);
  return {
    kpis: readKpis(root),
    ranking: readRanking(root),
    dias: readDias(root),
  };
};

export const filterRanking = (ranking, regra) => {
  if (!regra) return ranking || [];
  return (ranking || []).filter((row) => row.regras.includes(regra));
};

/** Dias com regra (R1–R5) de um inspetor, um item por data, do mais antigo ao mais recente. */
export const groupDiasProblema = (dias, inspetorId) => {
  const map = new Map();
  (dias || []).forEach((row) => {
    if (String(row.inspetorId) !== String(inspetorId)) return;
    if (!row.regras || row.regras.length === 0 || !row.dataKey) return;
    if (!map.has(row.dataKey)) {
      map.set(row.dataKey, {
        id: row.dataKey,
        data: row.data,
        regras: [],
        detalhes: [],
        jornadaId: row.jornadaId || null,
      });
    }
    const bucket = map.get(row.dataKey);
    row.regras.forEach((id) => {
      if (!bucket.regras.includes(id)) bucket.regras.push(id);
    });
    (row.detalhes || []).forEach((texto) => {
      if (texto && !bucket.detalhes.includes(texto)) bucket.detalhes.push(texto);
    });
    if (!bucket.jornadaId && row.jornadaId) bucket.jornadaId = row.jornadaId;
  });
  return [...map.values()].sort((a, b) => a.data.valueOf() - b.data.valueOf());
};

const canonicalRegime = (value) => {
  const text = String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();
  if (text.startsWith('INTERMIT')) return 'INTERMITENTE';
  if (text.startsWith('INDETERMIN') || text.startsWith('INTERMIN')) return 'INDETERMINADO';
  return null;
};

export const labelRegime = (value) => {
  const key = canonicalRegime(value);
  if (key === 'INTERMITENTE') return 'Intermitente';
  if (key === 'INDETERMINADO') return 'Indeterminado';
  return value ? String(value) : '—';
};

/** A aba recorta o BI completo no browser. O filtro `regimes` da API não separa Indeterminado. */
export const filterReportByRegime = (report, regime) => {
  if (!regime || !report) return report;
  const ranking = (report.ranking || []).filter((row) => canonicalRegime(row.regime) === regime);
  const ids = new Set(ranking.map((row) => String(row.inspetorId)));
  const dias = (report.dias || []).filter((row) => ids.has(String(row.inspetorId)));
  const kpis = { ...EMPTY_KPIS };
  REGRAS.forEach((regra) => {
    const people = ranking.filter((row) => row.regras.includes(regra.id));
    const diasRegra = dias.filter((row) => row.regras.includes(regra.id));
    kpis[regra.id] = {
      inspetores: people.length,
      dias: diasRegra.length ? diasRegra.length : null,
      horas: null,
    };
  });
  return { ...report, ranking, dias, kpis };
};

export const buildApiBody = (view) => ({
  inicio: view.inicio,
  fim: view.fim,
  secoes: SECOES,
});

const parseEpochDate = (value, boundary) => {
  if (!value) return null;
  const parsed = moment(value, URL_DATE_FORMAT, true);
  if (!parsed.isValid()) return null;
  return boundary === 'end' ? parsed.endOf('day').valueOf() : parsed.startOf('day').valueOf();
};

export const parseViewFromSearch = (search, fallback = getDefaultView()) => {
  const q = new URLSearchParams(search || '');
  const view = { ...fallback };
  const inicio = parseEpochDate(q.get('inicio'), 'start');
  const fim = parseEpochDate(q.get('fim'), 'end');
  if (inicio != null) view.inicio = inicio;
  if (fim != null) view.fim = fim;
  const cicloParam = q.get('ciclo');
  if (cicloParam === CICLO_ATUAL || cicloParam === CICLO_PASSADO || cicloParam === CICLO_CUSTOM) {
    view.ciclo = cicloParam;
  } else {
    view.ciclo = inferCiclo(view.inicio, view.fim);
  }
  if (view.ciclo !== CICLO_CUSTOM) {
    const period = periodForCiclo(view.ciclo);
    view.inicio = period.inicio;
    view.fim = period.fim;
  }
  const regime = q.get('regime');
  view.regime = regime === 'INTERMITENTE' || regime === 'INDETERMINADO' ? regime : null;
  const regra = canonicalRegra(q.get('regra'));
  view.regra = regra && regra !== 'EXTRA_100' ? regra : null;
  view.inspetorId = q.get('inspetorId') || null;
  view.visao = q.get('visao') === 'calendario' ? 'calendario' : null;
  const mes = q.get('mes');
  if (mes && moment(mes, MES_FORMAT, true).isValid()) view.mes = mes;
  else view.mes = moment(view.fim).format(MES_FORMAT);
  return view;
};

export const buildSearchFromView = (view) => {
  const q = new URLSearchParams();
  if (view?.ciclo) q.set('ciclo', view.ciclo);
  if (view?.inicio != null) q.set('inicio', moment(view.inicio).format(URL_DATE_FORMAT));
  if (view?.fim != null) q.set('fim', moment(view.fim).format(URL_DATE_FORMAT));
  if (view?.regime) q.set('regime', view.regime);
  if (view?.regra) q.set('regra', view.regra);
  if (view?.inspetorId) q.set('inspetorId', view.inspetorId);
  if (view?.visao === 'calendario') q.set('visao', 'calendario');
  if (view?.mes) q.set('mes', view.mes);
  return q.toString();
};

export const viewsEqual = (a, b) => buildSearchFromView(a) === buildSearchFromView(b);

export const monthOverlapsPeriod = (mes, inicio, fim) => {
  const start = moment(mes, MES_FORMAT, true).startOf('month');
  const end = start.clone().endOf('month');
  return end.valueOf() >= inicio && start.valueOf() <= fim;
};
